import { supabase } from '../supabaseClient';

// Retourne le % à appliquer par défaut à un nouveau partenaire :
// 1) percent d'un sous admin existant (pour rester aligné avec les autres)
// 2) sinon 100 - percent du super_admin (cas du tout premier partenaire)
// 3) sinon 0
export async function getDefaultPartnerPercent() {
  const { data: existing } = await supabase
    .from('admin_Profile')
    .select('percent')
    .eq('role', 'sous admin')
    .not('percent', 'is', null)
    .limit(1)
    .maybeSingle();

  if (existing && typeof existing.percent === 'number') {
    return existing.percent;
  }

  const { data: superAdmin } = await supabase
    .from('admin_Profile')
    .select('percent')
    .eq('role', 'super_admin')
    .limit(1)
    .maybeSingle();

  if (superAdmin && typeof superAdmin.percent === 'number') {
    return 100 - superAdmin.percent;
  }

  return 0;
}
